export const EMPTY_STORAGE_HOOK_RESULT = {
  loadStorageFilterField: () => null,
  saveStorageFilterField: () => {},
  removeStorageFilterField: () => {},
};

export const ADD_TO_ASYNC_FILTER_CONFIGS_SYMBOL = Symbol('Add to async filter configs');
